import { ArrowLeftRight, Button, Card, CardContent, CardHeader, CardTitle } from '@chain-zen/ui'

export function BackhaulEmptyState({ loadsPageURL }: { loadsPageURL: string }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <ArrowLeftRight className="h-5 w-5 text-primary" />
          Backhauls
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col items-center space-y-2 text-center">
          <p>No matching backhauls</p>
          <p className="text-sm text-muted-foreground">Click our load board to see matching loads</p>
          <Button variant="outline" onClick={() => window.open(`${loadsPageURL}/public/posts`)}>
            View Load Board
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
